// src/components/layouts/admindashboard/sidebar/sub/MenuItem.tsx

import React from "react";
import { NavLink } from "react-router-dom";
import * as Icons from "lucide-react";

interface MenuItemProps {
  item: {
    name: string;
    icon: string;
    path: string;
    tourId?: string;

  };
  onMobileClose: () => void;
}

const MenuItem: React.FC<MenuItemProps> = ({ item, onMobileClose }) => {
  const IconComponent = (Icons as any)[item.icon] || Icons.HelpCircle;
  const isExact = item.path === "/admin/dashboard/home";

  return (
    <NavLink
      to={item.path}
      onClick={onMobileClose}
      end={isExact}
      data-tour={item.tourId}

      className={({ isActive }) =>
        `group relative flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-all duration-200
        ${isActive
          ? "bg-gradient-to-r from-accent/20 to-transparent text-white shadow-sm"
          : "text-white/90 hover:bg-white/5 hover:text-white"
        }`
      }
    >
      {({ isActive }) => (
        <>
          {/* Barre latérale d'activation */}
          {isActive && (
            <span className="absolute left-0 w-1 h-6 rounded-r-full bg-accent shadow-[0_0_6px_#FBC02D]" />
          )}

          <IconComponent
            size={18}
            className={`transition-all duration-300 ${isActive
                ? "text-accent scale-110 drop-shadow-glow"
                : "text-white/90 group-hover:text-accent group-hover:scale-110"
              }`}
          />
          <span className="flex-1">{item.name}</span>

          {isActive && (
            <div className="w-1.5 h-1.5 rounded-full bg-accent shadow-[0_0_8px_#FBC02D] animate-pulse" />
          )}
        </>
      )}
    </NavLink>
  );
};

export default MenuItem;